import { Effect, Schema } from "effect";
import { Option, ParseResult } from "effect";
import { SecretSealerService } from "./sealing/SecretSealerService";
import { SecretUnsealerService } from "./unsealing/SecretUnsealerService";
//
// Secret Sealer Key Id
//
export const SecretSealerKeyId = Schema.String.pipe(Schema.brand("@open-revenue/utils/SecretSealer/SecretSealerKeyId"), Schema.annotations({
    identifier: "SecretKeyId",
    description: "A secret key id"
}));
//
// Public Key
//
export const SecretSealerPublicKey = Schema.String.pipe(Schema.brand("@open-revenue/utils/SecretSealer/SecretSealerPublicKey/Base64"), Schema.annotations({
    identifier: "SecretPublicKey",
    description: "A secret public key"
}));
//
// Private Key (Used for unsealing)
//
export const SecretSealerPrivateKey = Schema.String.pipe(Schema.brand("@open-revenue/utils/SecretSealer/SecretSealerPrivateKey/Base64"), Schema.annotations({
    identifier: "SecretPrivateKey",
    description: "A secret private key"
}));
//
// Sealed Secret Value
//
const SealedSecretValueStringSchemaBase = Schema.TemplateLiteral(Schema.Literal("v1:"), Schema.String, Schema.Literal(":"), Schema.String // The encrypted secret value
);
export const SealedSecretValueStringSchema = SealedSecretValueStringSchemaBase.pipe(Schema.brand("@open-revenue/utils/SealedSecret"), Schema.annotations({
    identifier: "SealedSecret",
    description: "A sealed secret"
}));
export const SealedSecretValueStructSchema = Schema.Struct({
    keyId: SecretSealerKeyId,
    encryptedSecretValue: Schema.String
});
export const SealedSecretValueStructFromString = Schema.transform(SealedSecretValueStringSchema, SealedSecretValueStructSchema, {
    encode: (value)=>`v1:${value.keyId}:${value.encryptedSecretValue}`,
    decode: (value)=>{
        const [version, keyId, encryptedSecretValue] = value.split(":");
        return {
            keyId,
            encryptedSecretValue
        };
    },
    strict: true
});
export const makeSealedValue = (schema)=>Schema.transformOrFail(// The sealed screct
    SealedSecretValueStringSchema, // The unsealed value,
    schema, {
        strict: true,
        decode: (fromA, options, ast, fromI)=>Effect.gen(function*() {
                const unsealerOption = yield* Effect.serviceOption(SecretUnsealerService);
                if (Option.isNone(unsealerOption)) {
                    return ParseResult.fail(new ParseResult.Type(ast, fromI, "SecretUnsealerService is not available"));
                }
                const unsealer = unsealerOption.value;
                const unsealed = yield* unsealer.unsealSecretValue(fromA).pipe(Effect.catchAll((e)=>ParseResult.fail(new ParseResult.Type(ast, fromI, e.message))));
                return unsealed;
            }),
        encode: (toA, options, ast, toI)=>Effect.gen(function*() {
                const secretSealer = yield* SecretSealerService;
                const sealed = yield* secretSealer.sealSecretValue(toA).pipe(Effect.catchAll((e)=>ParseResult.fail(new ParseResult.Type(ast, toI, e.message))));
                return sealed;
            })
    });
export const makeSealedValueWithBrand = (schema, brand)=>Schema.transformOrFail(// The sealed screct
    SealedSecretValueStringSchemaBase.pipe(Schema.brand(brand)), // The unsealed value,
    schema, {
        strict: true,
        decode: (fromA, options, ast, fromI)=>Effect.gen(function*() {
                const unsealerOption = yield* Effect.serviceOption(SecretUnsealerService);
                if (Option.isNone(unsealerOption)) {
                    return ParseResult.fail(new ParseResult.Type(ast, fromI, "SecretUnsealerService is not available"));
                }
                const unsealer = unsealerOption.value;
                const unsealed = yield* unsealer.unsealSecretValue(fromA).pipe(Effect.catchAll((e)=>ParseResult.fail(new ParseResult.Type(ast, fromI, e.message))));
                return unsealed;
            }),
        encode: (toA, options, ast, toI)=>Effect.gen(function*() {
                const secretSealer = yield* SecretSealerService;
                const sealed = yield* secretSealer.sealSecretValue(toA).pipe(Effect.catchAll((e)=>ParseResult.fail(new ParseResult.Type(ast, toI, e.message))));
                return sealed;
            })
    });
